import './styles/Header.css';
import AccountMenu from './AccountMenu';
import { Link } from "react-router-dom";
import { useLayoutEffect, useState } from 'react';
import Cookies from 'js-cookie';
import ReactGA from 'react-ga4';
import { useLocation, useSearchParams } from "react-router-dom";
import { useEffect } from 'react';
import { IsDev, GetAccessToken } from './Utilities';
import RedditPixel from 'react-reddit-pixel';
import webContentStrings from "./ContentStrings/LocalizedStrings.js";

ReactGA.initialize('G-P1CP4P4GZ6');

function Header({ status, setStatus }) {
    const [size, setSize] = useState([0, 0]);

    const location = useLocation();

    const [queryParams] = useSearchParams();

    useEffect(() => {
        GetAccessToken();
        RedditPixel.init('a2_f8s8vf4d4enx');
        RedditPixel.pageVisit();
    }, []);

    useEffect(() => {
        if (process.env.NODE_ENV !== "production") return;
        ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }, [location]);

    useLayoutEffect(() => {

        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }

        window.addEventListener('resize', updateSize);
        updateSize();
    }, []);


    return (
        <header className="headerParentList">
            <ul className="headerLine">
                <li className="logo">
                    <div className="logoHeaderDiv" onClick={() => window.location.assign("/")}>
                        <a href='/'><img src="/IconTransparent.png" /></a>
                        <p className="headerTitle">LUDARE</p>
                    </div>
                </li>
                {size[0] >= 1000 && <ExpandedHeader status={status} setStatus={setStatus} />}
                {size[0] < 1000 && <CollapsedHeader status={status} setStatus={setStatus} />}
            </ul>
        </header>
    );
}

function ExpandedHeader({ status, setStatus }) {
    const location = useLocation();

    return (
        <div className="expandedHeaderParent">
            <ul className="headerButtons">
                <li className={"headerLink" + (location.pathname === "/contactUs" ? "Selected" : "")}><a href="/contactUs">{webContentStrings.headerStrings.contact}</a></li>
                <li className={"headerLink" + (location.pathname === "/Library" ? "Selected" : "")}><a href="/Library">{webContentStrings.headerStrings.library}</a></li>
                <li className={"headerLink" + (location.pathname === "/studios" ? "Selected" : "")}><a href="/studios">{webContentStrings.headerStrings.studios}</a></li>
                <li className={"headerLink" + (location.pathname === "/players" ? "Selected" : "")}><a href="/players">{webContentStrings.headerStrings.players}</a></li>
                <li className={"headerLink" + (location.pathname === "/" ? "Selected" : "")}><a href="/">{webContentStrings.headerStrings.home}</a></li>
            </ul>
            <div className="account"><AccountMenu status={status} setStatus={setStatus} collapsed={false} /></div>
        </div>
    );
}

//{status === true && <li className="subscriptionLink"><a href="/account/subscription">{webContentStrings.headerStrings.subscription}</a></li> }

function CollapsedHeader({ status, setStatus }) {
    const [hovered, setHovered] = useState(false);

    function SignOut() {

        if (Cookies.get("LudareRefreshToken") === undefined) return;

        GetAccessToken().then((token) => {

            const reqOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 'RefreshToken': Cookies.get("LudareRefreshToken"), 'AccessToken': token })
            };

            fetch(process.env.REACT_APP_NODE_ADDRESS + '/Logout', reqOptions)
                .then((res) => res.json())
                .then((data) => {
                    //if (data.AccessToken === "" || data.AccessToken === undefined) return;
                    Cookies.remove("LudareAccessToken");
                    Cookies.remove("LudareRefreshToken");
                    setStatus(false);
                });
        });
    };

    return (
        <div className="collapsedDiv"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(true)}
        >
            <p className="collapsedMenu">{webContentStrings.headerStrings.menu}</p>
            {hovered && <ul className="collapsedMenuList">
                <li className="collapsedStudiosLink"><a href="/studios">{webContentStrings.headerStrings.studios}</a></li>
                <li><hr /></li>
                <li className="collapsedPlayerLink"><a href="/players">{webContentStrings.headerStrings.players}</a></li>
                <li><hr /></li>
                <li className="collapsedContactLink"><a href="/contactUs">{webContentStrings.headerStrings.contact}</a></li>
                <li><hr /></li>
                <li className="collapsedLibraryLink"><a href="/library">{webContentStrings.headerStrings.library}</a></li>
                <li><hr /></li>
                <li className="collapsedSignUpLink"><AccountMenu status={status} setStatus={setStatus} collapsed={true} /></li>
                
                
            </ul>}
        </div>
    );
}

//<li className="homeLink"><a href="/">Home</a></li>
//<li className="collapsedHomeLink"><a href="/">Home</a></li>
//<li><hr /></li>

export default Header;

/*{(status === false && process.env.NODE_ENV === "development") && <div>
                    <li className="account"><AccountMenu status={status} setStatus={setStatus} /></li>
                </div>}*/
